import GenerateCSR from "../../../../src/courses/partials/ssl/generate-csr.mdx";
import * as React from 'react';
export default {
  GenerateCSR,
  React
};